<template>
    <div class="top-stories-slider">
        <slider-article v-for="(article, index) in articles" :article="article"></slider-article>
    </div>
</template>

<script>
import SliderArticle from "@/parts/home/slider/SliderArticle.vue";

export default {
    name: "Slider",
    components: {SliderArticle},
    props: {
        articles: {
            type: Array,
            default: []
        },
    },
    data() {
        return {}
    },
    mounted() {
        $('.top-stories-slider').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: true,
            centerPadding: '25px',
            autoplay: true,
            autoplaySpeed: 7000,
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        dots: false,
                        slidesToShow: 2,
                        arrows: false,
                        slidesToScroll: 1,
                        // centerMode: true,
                        // centerPadding: '60px',
                    }
                },
                {
                    breakpoint: 960,
                    settings: {
                        dots: false,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        // centerMode: true,
                        centerPadding: '60px',
                        // variableWidth: true,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        dots: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        // centerMode: true,
                        centerPadding: '60px',
                        respondTo: 'min',
                        // variableWidth: true,
                        arrows: false,
                    }
                },

            ]
        });
    }


}

</script>

<style scoped>

</style>
